import { render, staticRenderFns } from "./subir.vue?vue&type=template&id=29f8fcb2"
import script from "./subir.vue?vue&type=script&lang=js"
export * from "./subir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports